import React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';

import { AddPermission } from './AddPermission';
import { AddRole } from './AddRole';
import { EditRole } from './EditRole';
import { PermissionList } from './PermissionList';
import { RoleList } from './RoleList';
import { WorkerList } from './WorkerList';

export const RolePermission = (props: RouteComponentProps) => (
  <Switch>
    <Route path={`${props.match.path}/role/list`} component={RoleList} />
    <Route path={`${props.match.path}/permission/list`} component={PermissionList} />
    <Route path={`${props.match.path}/worker/list`} component={WorkerList} />

    <Route path={`${props.match.path}/role/create`} component={AddRole} />
    <Route path={`${props.match.path}/role/:id/update`} component={EditRole} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/screens/rolePermission/RolePermission.tsx